import React from "react";

export default () => (
  <div>
    <p>Page not found</p>
  </div>
);
